import { jsx } from 'react/jsx-runtime';
import React from 'react';
import AppleLogo from './AppleLogo.js';
import BancontactLogo from './BancontactLogo.js';
import DotpayLogo from './DotpayLogo.js';
import IdealLogo from './IdealLogo.js';
import KlarnaLogo from './KlarnaLogo.js';
import MultibancoLogo from './MultibancoLogo.js';
import OPLogo from './OPLogo.js';
import Pawloader from './PawLoader.js';
import PaypalLogo from './PaypalLogo.js';
import PaytrailLogo from './PaytrailLogo.js';
import SepaLogo from './SepaLogo.js';
import TrustlyLogo from './TrustlyLogo.js';
import TwintLogo from './TwintLogo.js';

const Svg = {
    appleLogo: AppleLogo,
    bancontactLogo: BancontactLogo,
    dotpayLogo: DotpayLogo,
    idealLogo: IdealLogo,
    klarnaLogo: KlarnaLogo,
    multibancoLogo: MultibancoLogo,
    opLogo: OPLogo,
    pawLoader: Pawloader,
    paypalLogo: PaypalLogo,
    paytrailLogo: PaytrailLogo,
    sepaLogo: SepaLogo,
    trustlyLogo: TrustlyLogo,
    twintLogo: TwintLogo,
};
var Svgs = ({ type, className, ...props }) => (jsx("div", { className: className, children: React.createElement(Svg[type], props) }));

export { Svgs as default };
//# sourceMappingURL=index.js.map
